import style from './layer-access.scss';
import { MAPBOX_ACCESS_TOKEN, MAPBOX_ZOOM_LEVEL, MAPBOX_SKIN } from './../../../assets/js/mapbox';

const script = () => {
  const cssClass: string = 'LayerAccess';
  const cssClassAddress: string = 'ListAccess';
  const target: string = `.${cssClass} .${cssClassAddress}`;
  const targets: any = document.querySelectorAll(target);

  for (const elt of targets) {

    // test if element is init
    if (elt.dataset[`init${cssClass}`]) {
      return true; // already init go to next iteration
    }
    // init element
    elt.dataset[`init${cssClass}`] = true;

    // Get latitude and longitude of address
    const latitude = parseFloat(elt.getAttribute('data-lat'));
    const longitude = parseFloat(elt.getAttribute('data-lng'));

    if (!isNaN(latitude) && !isNaN(longitude)) {

      // Init map
      const map = document.createElement('div');
      map.classList.add(`${cssClass}-map`);

      const mapImg = document.createElement('img');
      const imgSize = '500x500@2x';
      mapImg.setAttribute('src', `https://api.mapbox.com/styles/v1/mapbox/${MAPBOX_SKIN}/static/${longitude},${latitude},${MAPBOX_ZOOM_LEVEL},0/${imgSize}?access_token=${MAPBOX_ACCESS_TOKEN}`);
      map.appendChild(mapImg);

      const wrapper = elt.closest(`.${cssClass}-wrapper`);
      wrapper.appendChild(map);
    }
  }
};

export {
  style,
  script,
};
